import { CrudAbstractModel } from "../crud-abstract/crud-abstract.model";

export class BaseTier extends CrudAbstractModel {
  constructor(
    public id: number,
    protected discriminator: string,
    protected name: string,
    protected description: string,
  ) {
    super(id);
  }

  public getDiscriminator(): string {
    return this.discriminator;
  }
  public getName(): string {
    return this.name;
  }
  public getDescription(): string {
    return this.description;
  }

  public getRequestParams(): void {
    return null;
  }
}
